import React from 'react';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import { Text } from '../../../../../../components/textVariations';
import { CPImage } from '../../../../../../components/imageWrapper/CPImage';

export const ModalHelper = ({
  showModal,
  data,
  showModalImg,
  transformedGatsbyImageData,
}: UnitAvailabilityTypes.TModalTypes) => {
  if (transformedGatsbyImageData) {
    return (
      <div className={`modal ${showModal ? 'is-active' : ''}`}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head is-flex is-justify-content-end">
            <Text className="modal-card-title unitTypeName">
              {data.customArt && data.customArt.unit_type_description_title}{' '}
              &nbsp;&nbsp;
            </Text>
            <button
              className="delete is-large"
              aria-label="close"
              onClick={showModalImg}
            ></button>
          </header>
          <div className="modal-card-body">
            <CPImage gatsbyImageData={transformedGatsbyImageData} />
          </div>
          <footer className="modal-card-foot is-flex is-justify-content-center">
            <Text className="unitTypedescription">
              {data.customArt &&
                data.customArt.unit_type_description_description}
            </Text>
          </footer>
        </div>
      </div>
    );
  }
  return <></>;
};
